'use client';

import { initLanguages, initI18n } from '@/utils/i18n';
import { useParams } from 'next/navigation';

/**
 * Supported languages
 */
export type Languages = 'en';
export const { languages, names } = initLanguages<Languages>({
  en: 'English',
});

export const provider = initI18n<Languages>({
  useLang: () => {
    // In App Router, we use the [lang] dynamic segment
    // but for simplicity in the migration, we're using 'en' only
    return 'en';
  },
});

export function useLang() {
  const lang = provider.useLang();
  return {
    lang,
    setLang(lang: Languages) {
      // Navigation should be handled by useRouter from next/navigation
      // but for simplicity in the migration, we're using 'en' only
      console.log(`Language would change to: ${lang}`);
    },
  };
}
